<template>
  <button
    @click="$emit('toggle')"
    class="ml-2 btn btn-square text-nowrap comment-trigger d-flex justify-content-center align-items-center"
    :class="{
      'btn-purple' : unread.length && !showing,
      'btn-secondary' : !unread.length || showing
    }"
  >
    <i class="fal fa-comment-alt-lines"></i>
    <small v-if="amount" class="ml-1">{{ amount }}</small>
  </button>
</template>

<script>
export default {
  props: {
    comments: {
      type: Array,
      default: () => [],
    },
    showing: Boolean,
  },

  data() {
    return {
      commentsData: this.comments,
    };
  },

  computed: {
    amount() {
      return this.comments.length > 0 ? this.comments.length : '';
    },

    label() {
      if (this.showing) {
        return '<span class="d-inline-block px-2">Hide Comments</span>';
      }
      let amount = '';
      if (this.unread.length) {
        amount = ` <small>${this.unread.length}</small>`;
      }
      return `<i class="fal fa-comment-alt-lines"></i>${amount}`;
    },

    unread() {
      const { id } = this.$page.props.auth.user;
      const unread = this.commentsData.filter((comment) => !comment.read_by.includes(id));
      return unread;
    },
  },
};
</script>
